import moment from 'moment';
import { fetchRule } from '@common-components/schedule-picker/recurrence-utils';
import { recurrenceCadenceSentence, type Translate } from '@common/i18n/recurrence-cadence';

/**
 * A localized "how often does this repeat" sentence, from a serialized rruleset.
 *
 * rrule's own `toText()` is English-only — a Hebrew user reading the hover card
 * got "Repeats every week on Monday" in the middle of an otherwise Hebrew
 * screen. The GRAMMAR now lives in `@common/i18n/recurrence-cadence`, which has
 * no imports of its own; this file is the thin adapter that parses the rule
 * string and supplies moment's weekday names. The split exists so the compose
 * dialog's own preview (`generateRecurrenceText`, inside recurrence-utils) can
 * use the same clause without closing an import cycle back through this module.
 *
 * Never throws: an unparseable or exotic rule yields '', and the caller simply
 * omits the line (an empty string is better than leaking English).
 */
export function buildRecurrenceSentence(
    rruleset: string | undefined | null,
    t: Translate,
): string {
    if (!rruleset) return '';
    try {
        // moment's GLOBAL locale, which the calendar container has already
        // switched to the UI language before anything here renders.
        return recurrenceCadenceSentence(fetchRule(rruleset).options, moment.weekdays(), t);
    } catch {
        return '';
    }
}
